import React from "react";
import { Link } from "react-router-dom";
import "./Banner.css";
import DrivingCarLottie from "../../common_components/animation/driving_car_lottie/Driving_Car_Lottie";

function Banner() {
  return (
    <section className="home_banner">
      <div className="container">
        <div className="banner_container">
          <div className="banner_text">
            <h1>Expert Car Repair & Maintenance —</h1>
            <h1 className="highlight">Anytime, Anywhere!</h1>
            <p>
              Book trusted car services in minutes, track live updates, and
              enjoy doorstep pickup & delivery — all through one easy-to-use
              app.
            </p>
            <div className="btn_container">
              <a
                href="https://play.google.com/store/apps/details?id=com.mobile.gravity_drive&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/book_your_vehicle/google_play.png"
                  alt="Get it on Google Play"
                  className="google_play_badge"
                />
              </a>

              <Link to="/services/maintenance" className="book_service_text">
                Book a Service
              </Link>
            </div>
          </div>

          <div className="banner_animation">
            <DrivingCarLottie />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
